export default __webpack_public_path__ + "static/wltetris-28c4a1809d07293d894d2d9135bf776b.jpg";